document.addEventListener("DOMContentLoaded", () => {
  const videos = document.querySelectorAll(".product__media video");

  videos.forEach((v) => {
    // Required for iOS autoplay
    v.muted = true;
    v.playsInline = true;
    v.loop = true;

    v.setAttribute("muted", "");
    v.setAttribute("playsinline", "");
    v.setAttribute("loop", "");
    v.setAttribute("autoplay", "");

    // This is the key part
    v.controls = false;
    v.removeAttribute("controls");

    // Play safely
    const play = () => {
      const p = v.play();
      if (p && p.catch) p.catch(() => {});
    };

    // Play once ready
    if (v.readyState >= 2) {
      play();
    } else {
      v.addEventListener("loadeddata", play, { once: true });
    }

    // Safety loop
    v.addEventListener("ended", () => {
      v.currentTime = 0;
      play();
    });
  });
});
